import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AssetModel } from '../_models/asset.model';
import { Subscription } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { UUID } from 'angular2-uuid';
import { UserService } from '../../auth/_services/user.service';

const API_ASSET_URL = '/api/asset';
const API_URL = environment.API_URL;

@Injectable({
  providedIn: 'root'
})
export class AssetService {

  assetList: any[];
  assetListChanged = new EventEmitter<any[]>();
  maintenanceDataChanged = new EventEmitter<any>();

  constructor(private readonly http: HttpClient,
    private readonly userService: UserService) { }

  emptyAsset(){
    this.assetList = [];
    this.assetListChanged.emit([]);
  }

  getAsset(s?: string, observableReturnFlag = false, fields = '') {
    const url = API_URL + API_ASSET_URL;
    let params = new HttpParams();
    if (s) {
      params = params.set('system', s);
    }
    if (fields) {
      params = params.set('fields', fields)
    }
    const options = {
      headers: this.userService.getHttpAuthHeader(),
      params: params
    };

    if (observableReturnFlag) {
      return this.http.get(url, options);
    }

    this.http.get(url, options).subscribe((data: any) => {
      this.assetList = data.data;
      this.assetListChanged.emit(data.data);
    });
  }

  editTooltip(selection: any) {
    if (selection.selected.length) {
      return "Edit Record";
    }
    return "Please select a record";
  }


  getAssetBySystem(id, observableReturnFlag = false, fields = null) {
    let url = API_URL + API_ASSET_URL;
    let httpParams = new HttpParams().set('system', id);

    if (fields) {
      httpParams = httpParams.set('fields', fields);
    }

    if (observableReturnFlag) {
      return this.http.get(url, { params: httpParams, headers: this.userService.getHttpAuthHeader() });
    }

    this.http.get(url, { params: httpParams, headers: this.userService.getHttpAuthHeader() }).subscribe((data: any) => {
      this.assetList = data.data;
      this.assetListChanged.emit(data.data);
    });
  }

  getAssetByFacility(id, observableFlag = false, fields = null) {
    let url = API_URL + API_ASSET_URL;
    let httpParams = new HttpParams().set('facility', id);

    if (fields) {
      httpParams = httpParams.set('fields', fields);
    }

    return this.http.get(url, { params: httpParams, headers: this.userService.getHttpAuthHeader() });
  }
  _addLinkField(s){
    let isArray = Array.isArray(s)
    if(isArray){
      s.forEach(el => {
        if(!el.link){
          el['link'] = UUID.UUID();
        }
      });
    }else{
      if(!s.link){
        s['link'] = UUID.UUID();
      }
    }
  }

  createAsset(a: Partial<AssetModel>) {

    let asset = {
      name: a.name.trim(),
      make: a.make,
      assetType: a.assetType,
      image: a.image,
      unit: a.unit,
      facility: a.facility,
      failure: [],
      system: a.systemId, /* systemId is an array of sytemIds */
		  maintenance: JSON.parse((a.maintenance ? a.maintenance : '[""]')),
      provider: a.provider,
      details: a.details,
      isSMB: a.isSMB ? true : false
    }
    this._addLinkField(asset);
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');

    return this.http.post<AssetModel>(API_URL + API_ASSET_URL, asset, { headers: this.userService.getHttpAuthHeader() })
  }

  createBulkAsset(a_list: AssetModel[]) {

    this._addLinkField(a_list);

    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');

    return this.http.post<AssetModel>(API_URL + API_ASSET_URL, a_list, { headers: this.userService.getHttpAuthHeader() })
  }

  updateAsset(a: Partial<AssetModel>) {
    let asset = {
      _id: a._id,
      name: a.name.trim(),
      image: a.image,
      make: a.make,
      unit: a.unit,
      facility: a.facility,
      failure: a.failure,
      system: a.systemId,/* systemId is an array of sytemIds */
      maintenance: JSON.parse(a.maintenance ? a.maintenance : '[""]'),
      provider: a.provider,
      link: a.link,
      details: a.details,
      isSMB: a.isSMB ? true : false
    }
    this._addLinkField(asset);
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');

    return this.http.put<AssetModel>(API_URL + API_ASSET_URL, asset, { headers: this.userService.getHttpAuthHeader() })
  }

  updateAssetMaintenance(a: Partial<AssetModel>) {
    let asset = {
      _id: a._id,
      maintenance: JSON.parse(a.maintenance ? a.maintenance : '[""]')
    }
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.put<AssetModel>(API_URL + API_ASSET_URL, asset, { headers: this.userService.getHttpAuthHeader() })
  }

  /* deleteAsset(a: AssetModel, extras={}) {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    let params = {
      _id : a._id,
      ...extras
    }
    return this.http.delete<AssetModel>(API_URL + API_ASSET_URL, { params,  headers: this.userService.getHttpAuthHeader() });
  } */

    getAssetChanges(_id, fields = null) {
      let url = API_URL + '/api/userlog';
      let httpParams = new HttpParams().set('_id', _id);

      if (fields) {
        httpParams = httpParams.set('fields', fields);
      }

      return this.http.get(url, { params: httpParams, headers: this.userService.getHttpAuthHeader() });
    }

  getPIDDataForAsset(pids: String[]) {
    const pidString = pids.toString();
    const params = { pid: pidString };
    let url = API_URL + '/api/cognite/assetPid';
    return this.http.get(url, { params, headers: this.userService.getHttpAuthHeader() });
  }

  deleteAsset(a: any, extras={}) {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    let params = {
      _id : a,
      ...extras
    }
    return this.http.delete<AssetModel>(API_URL + API_ASSET_URL, { params,  headers: this.userService.getHttpAuthHeader() });
  }

  isDisable(recommendation, failure) {
    let loggedInUser:any = this.userService.getLoggedInUser()
    if ((!recommendation.internal || !failure.internal) && !loggedInUser.internal)
      return false
    else if (loggedInUser.internal)
      return false
    return true
  }

  checkUser(r) {
    let loggedInUser:any = this.userService.getLoggedInUser()
    if (loggedInUser.internal == false) {
      return false
    }
    else {
      if (!r.internal) {
        return true
      }
    }
    return false
  }

  checkVisisbility(r) {
    let loggedInUser:any = this.userService.getLoggedInUser()
    if (loggedInUser.internal == false && r.internal) {
      return false
    } else {
      return true
    }
  }

  disableUploadButton(){
    let loggedInUser:any = this.userService.getLoggedInUser()
    if(loggedInUser.internal == false )
      return true
    return false
  }

  hasDeployedSystem(systems) {
		return systems?.some(system => system.deployedVersion)
	}
}
